// The ONE route guard for agent navigation in the browser — the client twin
// of backend/shared/appCatalog.js isKnownRoute, over the same generated
// table (scripts/generate-entities.mjs scrapes App.js). The voice agent's
// navigate_app runs here (realtime tool calls never touch the server), so
// it must refuse exactly what the server refuses.
import routes from '../data/appRoutes.gen.json';

const HIDDEN = [/^\/login$/, /^\/u\//, /^\/sign\//, /^\/share\//, /^\/connect(\/|$)/, /^\/privacy$/, /^\/terms$/];

function matchPattern(pattern, concrete) {
  const rs = pattern.split('/').filter(Boolean);
  const segs = concrete.split('/').filter(Boolean);
  if (rs.length !== segs.length) return false;
  return rs.every((seg, i) => (seg.startsWith(':') ? /^[\w.-]+$/.test(segs[i]) : seg === segs[i]));
}

export function isKnownRoute(p) {
  const s = String(p ?? '').trim();
  if (!s || /\s/.test(s) || s.length > 300 || !s.startsWith('/')) return false;
  const [noHash, hash = ''] = s.split('#');
  if (hash && !/^[\w-]+$/.test(hash)) return false;
  const [base, query = ''] = noHash.split('?');
  if (query && !/^([\w-]+=[\w.%+-]*)(&[\w-]+=[\w.%+-]*)*$/.test(query)) return false;
  if (HIDDEN.some((re) => re.test(base))) return false;
  return routes.some((r) => matchPattern(r.path, base));
}
